import { useDispatch } from 'react-redux';
import type { Cart } from 'core/domains/cart';
import { actions } from 'core/use-cases/user';

type ImageType = {
  url: string;
  imageSize: string;
};

export const useModalUnavailableItems = () => {
  const dispatch = useDispatch();
  const getImage = (image: ImageType[]) => {
    return image.filter((img) => img.imageSize === 'small')[0].url;
  };

  const handleBuyIntention = (
    productCode: Cart['data']['items'][number]['productCode'],
    name: string,
  ) => {
    dispatch(actions.userBuyIntentionFetch.request({ productCode, quantity: 1, name }));
  };

  return {
    getImage,
    handleBuyIntention,
  };
};
